<!-- 新增编辑框 -->
<template>
  <a-modal
    :title="title"
    width="1000px"
    :visible="visible"
    @ok="onSave"
    @cancel="onClose"
    v-if="visible"
  >
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :colon="false"
      class="drawer-view"
    >
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="组织机构名称" prop="orgName">
            <InputText v-model="ruleForm.orgName" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="统一社会信用代码" prop="orgCode">
            <InputText
              v-model="ruleForm.orgCode"
              allowClear
              :disabled="title == '编辑'"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="上级组织机构" prop="parentName">
            <LenovoSelectModule
              :reset="true"
              placeholder="请输入"
              v-model="ruleForm.parentName"
              apiType="getPubOrganName"
              modelKey="name"
              :paramsListObj="{ name: 'name', id: 'id' }"
              @change="handleDepart"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="行政区划" prop="outRegion">
            <!-- <CascaderLazy
              v-model="outRegion"
              placeholder="请选择"
              allowClear
              @change="handleArea"
              :isShowDetail="isShowDetail"
            /> -->
            <a-cascader
              v-model:value="ruleForm.outRegion"
              :options="getAreaList"
              placeholder="请选择"
              expandTrigger="hover"
              @change="handleArea"
              :field-names="{
                label: 'name',
                value: 'id',
                children: 'children',
              }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="联系人" prop="orgMasterName">
            <InputText v-model="ruleForm.orgMasterName" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="联系方式" prop="orgPhone">
            <InputText v-model="ruleForm.orgPhone" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="24">
          <a-form-model-item label="地址" prop="orgAddr">
            <InputText v-model="ruleForm.orgAddr" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="状态" prop="dataStatus">
            <SelectModule
              v-model="ruleForm.dataStatus"
              apiType="getDictDataByCode"
              :apiParams="{ dictCode: 'organ_status' }"
              :showAll="true"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="机构级别">
            <SelectModule
              v-model="ruleForm.regionLevelCode"
              apiType="getDictDataByCode"
              :apiParams="{ dictCode: 'org_level' }"
              isAllShow="请选择"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { mapState } from "vuex";
import InputText from "@/components/form/InputText"; // 输入框组建
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
// import CascaderLazy from "@/components/form/CascaderLazy"; // 级联选择
import API from "@/api/sysManage.js"; // 请求接口
import SELAPI from "@/api/select"; // 请求接口

export default {
  components: {
    InputText,
    SelectModule,
    LenovoSelectModule,
    // CascaderLazy,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  computed: {
    title() {
      let str = "";
      if (JSON.stringify(this.modalData) != "{}") {
        str = "编辑";
      } else {
        str = "新增";
      }
      return str;
    },
    getAreaList() {
      return this.formatData(this.areaList)
      // return [
      //   {
      //     id: 'zhejiang',
      //     name: 'Zhejiang',
      //     children: [
      //       {
      //         id: 'hangzhou',
      //         name: 'Hangzhou',
      //         children: [
      //           {
      //             id: 'xihu',
      //             name: 'West Lake',
      //           },
      //         ],
      //       },
      //     ],
      //   },
      // ]
    },

    ...mapState(["areaList"]),
  },
  data() {
    return {
      ruleForm: {
        id: "", // 主键ID
        orgCode: "", // 统一社会信用代码
        orgName: "", // 组织机构名称
        parentName: "", // 上级组织机构id
        parentId: "", // 上级组织机构name
        orgMasterName: "", // 联系人
        orgPhone: "", // 联系方式
        orgAddr: "", // 地址
        dataStatus: "1", // 数据状态0停用1启用-字典(organ_status)
        regionLevelCode: "", // 机构级别-字典org_level
        outRegion: [], // 行政区划
      },
      outRegionName: [], // 行政区划
      rules: {
        orgName: [
          { required: true, message: "请输入组织机构名称!", trigger: "change" },
        ],
        orgCode: [
          {
            required: true,
            message: "请输入统一社会信用代码!",
            trigger: "change",
          },
        ],
        parentName: [
          {
            required: true,
            message: "请选择上级组织机构名称!",
            trigger: "change",
          },
        ],
        outRegion: [
          {
            required: true,
            message: "请选择行政区划!",
             trigger: "change",
          },
        ],
        orgMasterName: [
          { required: true, message: "请输入联系人!", trigger: "change" },
        ],
        orgPhone: [
          { required: true, message: "请输入联系方式!", trigger: "change" },
        ],
        orgAddr: [
          { required: true, message: "请输入地址!", trigger: "change" },
        ],
        dataStatus: [
          { required: true, message: "请选择状态!", trigger: "change" },
        ],
      },
      visible: false,
      isShowDetail: false, // 是否回显行政区划
      areaNewList: [],
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 选中行政区划
    handleArea(val, option) {
      console.log("val", val);
      console.log("option", option);
      // this.isShowDetail = false;
     
      this.outRegionName = option || [];
    },
    // 行政区划控制面板显示/隐藏
    visibleChange() {
      this.isShowDetail = false;
    },
    // 选择上级组织机构
    handleDepart(name, obj) {
      this.ruleForm.parentId = obj ? obj.id : "";
      this.ruleForm.parentName = obj ? obj.name : "";
    },
    // 获取角色详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.ruleForm.id,
          },
        },
      };
      API.getOrgDetailById(params, (callback) => {
        let data = {};
        if (callback.status == "S" && callback.data) {
          data = callback.data;
          for (let key in this.ruleForm) {
            if (data.hasOwnProperty(key)) {
              if (key == "dataStatus") {
                this.ruleForm[key] = data[key].toString() || "1";
              } else {
                this.ruleForm[key] = data[key] || "";
              }
            }
          }

          this.ruleForm.outRegion =
            [data["provinceCode"], data["cityCode"], data["countyCode"]] || [];
          this.outRegionName = [
            {
              id: data["provinceCode"],
              name: data["provinceName"],
            },
            {
              id: data["cityCode"],
              name: data["cityName"],
            },
            {
              id: data["countyCode"],
              name: data["countyName"],
            },
          ];


          if (this.ruleForm.outRegion && this.ruleForm.outRegion.length > 0) {
            this.isShowDetail = true;
          }
        }
      });
    },
    // 保存
    onSave() {
      // this.submit();
      this.$refs.ruleForm.validate((valid) => {
        let _this = this;
        if (valid) {
          _this.submit();
        }
      });
    },

    submit() {
      this.loading = true;
      let obj = {
        data: {
          params: {
            ...this.ruleForm,
            provinceCode:
              this.outRegionName && this.outRegionName[0]
                ? this.outRegionName[0].id
                : "", // 方行政区划
            cityCode:
              this.outRegionName && this.outRegionName[1]
                ? this.outRegionName[1].id
                : "", // 方行政区划（市）
            countyCode:
              this.outRegionName && this.outRegionName[2]
                ? this.outRegionName[2].id
                : "", // 行政区划（区）
            provinceName:
              this.outRegionName && this.outRegionName[0]
                ? this.outRegionName[0].name
                : "", // 方行政区划
            cityName:
              this.outRegionName && this.outRegionName[1]
                ? this.outRegionName[1].name
                : "", // 方行政区划（市）
            countyName:
              this.outRegionName && this.outRegionName[2]
                ? this.outRegionName[2].name
                : "", // 行政区划（区）
          },
        },
      };

      API.mergeOrgInfo(obj, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "";
          if (JSON.stringify(this.modalData) != "{}") {
            str = "编辑";
          } else {
            str = "新增";
          }
          this.$message.destroy();
          this.$message.success(`${str}成功`);
          this.$emit("handleFlag", false, {}, "ok");
        }
      });
    },
    //格式化数据，递归将空的children置为undefined
    formatData(list) {
      for (let i = 0; i < list.length; i++) {
        if (Array.isArray(list[i].children) && list[i].children.length > 0) {
          this.formatData(list[i].children);
        } else {
          this.$delete(list[i], "children");
        }
        return list;
      }

      // const that = this
      // data.forEach((element) => {
      //   if (element.children && element.children.length > 0) {
      //     that.formatData(element.children)
      //   } else {
      //     element.children = undefined
      //   }
      // })
      // console.log('data', data)
      return data
    },
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      this.areaNewList = this.formatData(this.areaList) || [];

      if (newVal) {
        this.ruleForm.id = this.modalData.id || "";
        // this.areaNewList = this.formatData(this.areaList) || [];
        if (JSON.stringify(this.modalData) != "{}") {
          // 编辑
          this.getDetail();
        }
      } else {
        this.outRegionName = [];
        // this.outRegion = [];
        this.isShowDetail = false;
        this.ruleForm = {
          id: "", // 主键ID
          orgCode: "", // 统一社会信用代码
          orgName: "", // 组织机构名称
          parentName: "", // 上级组织机构id
          parentId: "", // 上级组织机构name
          orgMasterName: "", // 联系人
          orgPhone: "", // 联系方式
          orgAddr: "", // 地址
          dataStatus: "1", // 数据状态0停用1启用-字典(organ_status)
          regionLevelCode: "",
          outRegion: []
        };
      }
    },
  },
};
</script>
